import { render } from "./ExpendableNavButton.vue?vue&type=template&id=25e0aeae&scoped=true"
import script from "./ExpendableNavButton.vue?vue&type=script&lang=js"
export * from "./ExpendableNavButton.vue?vue&type=script&lang=js"

import "./ExpendableNavButton.vue?vue&type=style&index=0&id=25e0aeae&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e0aeae"]])

export default __exports__